import { OrderPageData, SliderUIObjectData } from '../../../../../api';
import { findMultipleTicketsUiObject } from '../../../../../common/multipleTicketsUtils';

// The page's own word for the quantity: its persons slider or its tickets object, else the generic fallback.
export const quantityLabel = (orderPage: OrderPageData, language: string, fallback: string): string => {
  const sliderUiObject = orderPage.objects.find(
    (uiObject) => uiObject.type === 'slider' && (uiObject as SliderUIObjectData).data_type === 'persons',
  ) as SliderUIObjectData | undefined;
  const uiObject = sliderUiObject ?? findMultipleTicketsUiObject(orderPage);
  const label = uiObject?.label as Record<string, string | undefined> | undefined;
  return label?.[language] || fallback;
};
